const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NOGA-lijeva") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M266.8,332c-11.1,11.3-.4,20.9,3.5,21.4,6.4.8,17-1.5,10.3-17-1.5-5.3,17.9,8,20.5,9.2,8.3,3.7,17.6-7.8,10.2-16.2-.3-.3-3.2-.1-2.7-.6,6.6-7.2-1.4-12.8-3.2-13.4-1.8.1-12.7-1.3-12.4,11.6-2,2.8-15.5,5.2-16.6.5C270.6,327.5,267.7,330.1,266.8,332Z",
    style: {
      fill: "#f99422",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3859000205993652px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,328.7a8.16,8.16,0,0,0-7.2,1,6.5,6.5,0,0,0-2.5,6.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.7,335a10.87,10.87,0,0,0-9.8,8.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3575999736785889px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootLeft);
export default __webpack_public_path__ + "static/media/foot-left.eb8a73a1d79562a8782df81852fc48d8.svg";
export { ForwardRef as ReactComponent };